export default "__VITE_ASSET__DSU35g$C__"